export function slugify(input: string | null | undefined): string | null {
	if (!input) return null;
	const ascii = input.normalize("NFKD").replace(/\p{Diacritic}/gu, "");
	const out = ascii
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "");
	return out.length === 0 ? null : out;
}
